module.exports = {
    "xspace.client.xform.XImage.xeditorUploadImageImage": "Cargar imágenes",
    "xspace.client.xform.XImage.xeditorXImageAlign": "Alinear",
    "xspace.client.xform.XImage.xeditorXImageDeleteImage": "Eliminar imágenes",
    "xspace.client.xform.XImage.xeditorXImageDownloadImage": "Descargar imágenes",
    "xspace.client.xform.XImage.xeditorXImageImage": "Imágenes",
    "xspace.client.xform.XImage.xeditorXImageLeftAlign": "Desplazar a la izquierda",
    "xspace.client.xform.XImage.xeditorXImageNofloat": "Centrar",
    "xspace.client.xform.XImage.xeditorXImageReplaceImage": "Sustituir imágenes",
    "xspace.client.xform.XImage.xeditorXImageRestoreWidth": "Restaurar tamaño original",
    "xspace.client.xform.XImage.xeditorXImageRightAlign": "Desplazar a la derecha",
    "xspace.client.xform.dateRange.xformDefaultEndDatePlaceholder": "Fecha de finalización",
    "xspace.client.xform.dateRange.xformDefaultStartDatePlaceholder": "Fecha de comienzo",
    "xspace.client.xform.index.xformDefaultSubmitButtonLabel": "Enviar",
    "xspace.client.xform.index.xformUploaderImageFileCheckMessage": "Carga no es un archivos de imagen, por favor vuelva a subir fotos",
    "xspace.client.xform.insertbar.xeditorInsertbarMenuTitle": "Insertar",
    "xspace.client.xform.insertbar.xeditorInsertbarTool": "Herramientas",
    "xspace.client.xform.upload.xformBatchUploadDefaultLabel": "Subir",
    "xspace.client.xform.upload.xformBatchUploadToolTip": "Pulsa Ctrl/Command para agrupar los archivos subidos",
    "xspace.client.xform.upload.xformExampleImageLabel": "Imagen de ejemplo",
    "xspace.client.xform.upload.xformFileTemplateLabel": "Plantilla",
    "xspace.client.xform.upload.xformMaxFileNumErrorTip": "El archivo subido excede el límite máximo",
    "xspace.client.xform.upload.xformMaxFileSizeErrorTip": "Tamaño máximo del archivo subido:",
    "xspace.client.xform.upload.xformUploadErrorTip": "No se ha podido subir. Prueba de nuevo más tarde."
};